import React from 'react';
import cn from 'classnames';

import styles from './Plug.module.scss';

export interface PlugProps {
    icon: React.ReactNode;
    title: React.ReactNode;
    text: React.ReactNode;
    action?: React.ReactNode;
    size?: 'md' | 'sm';
}

const Plug: React.FC<PlugProps> = ({icon, title, text, action, size = 'md'}) => {
    return (
        <div className={cn(styles.container, size === 'sm' && styles.small)}>
            <div className={styles.content}>
                <span className={styles.icon}>
                    {icon}
                </span>
                <div className={styles.blockTitle}>
                    <span className={styles.title}>
                        {title}
                    </span>
                    <span className={styles.text}>
                        {text}
                    </span>
                </div>
                {
                    action && <div className={styles.action}>
                        {action}
                    </div>
                }
            </div>
        </div>
    );
};

export default Plug;
